<script>
import {
  pageTitleMixin,
  prefetchDataMixin,
} from '@ubic/vue-mixins';
import { permissions } from '@/constants';
import ErrorAccessDenied from '@/components/ErrorAccessDenied';
import FormError from '@/components/FormError';
import DeleteWithConfirm from '@/components/DeleteWithConfirm';
import ProjectFields from './components/ProjectFields';
import service from './service';

export default {
  pageTitle: 'Детали проекта',
  async prefetchData () {
    if (!this.hasReadPermission) {
      return;
    }

    this.isFetching = true;

    this.data = await service.getById(this.$route.params.id);

    this.name = this.data.name || '';
    this.search = this.data.search || '';
    this.isArchive = this.data.isArchive || false;
    this.isFetching = false;
  },
  mixins: [
    pageTitleMixin,
    prefetchDataMixin,
  ],
  data () {
    return {
      isFetching: false,
      isSaving: false,
      data: {},
      error: '',
      name: '',
      search: '',
    };
  },
  computed: {
    hasReadPermission () {
      return this.$store
        .getters['auth/checkPermission'](permissions.PROJECT_READ);
    },
    hasWritePermission () {
      return this.$store
        .getters['auth/checkPermission'](permissions.PROJECT_WRITE);
    },
  },
  methods: {
    handleFieldsChange ({ name, search, isArchive }) {
      this.name = name;
      this.search = search;
      this.isArchive = isArchive;
    },
    async handleSubmit (e) {
      e.preventDefault();

      if (this.isSaving || !this.hasWritePermission) {
        return;
      }

      this.isSaving = true;
      this.error = '';

      try {
        const { name, search, isArchive } = this;
        await service.update(
          this.$route.params.id,
          { name, search, isArchive }
        );

        this.emitDataUpdate();
        this.handleClose();
      } catch (err) {
        console.log(err);
        this.error = 'Ошибка при сохранении проекта';
        this.isSaving = false;
      }
    },
    async handleDelete () {
      if (!this.hasWritePermission) {
        return;
      }

      this.isFetching = true;

      try {
        await service.remove(this.$route.params.id);

        this.emitDataUpdate();
        this.handleClose();
      } catch (err) {
        this.error = 'Ошибка при удалении проекта';
        this.isFetching = false;
      }
    },

    handleClose () {
      this.$emit('close');
      this.$router.replace('/projects');
    },
    emitDataUpdate () {
      this.$emit('dataupdate');
    },
  },
  render () {
    if (!this.hasReadPermission) {
      return (
        <u-modal onClose={this.handleClose}>
          <ErrorAccessDenied />
        </u-modal>
      );
    }

    const { data, error, isSaving, hasWritePermission } = this;

    return (
      <u-modal onClose={this.handleClose}>
        <u-title
          slot="header"
          level="2"
        >
          <span>
            Проект
            &nbsp;
          </span>
          <span slot="sub">
            {data.name}
          </span>
        </u-title>

        {this.isFetching ? (
          <u-spinner />
        ) : (
          <form
            action="#"
            method="post"
            onSubmit={this.handleSubmit}
          >
            <ProjectFields
              values={data}
              disabled={isSaving}
              readonly={!hasWritePermission}
              onChange={this.handleFieldsChange}
            />

            {Boolean(error) && (
              <FormError>
                {error}
              </FormError>
            )}

            {hasWritePermission && (
              <footer class="form-footer">
                <u-btn
                  type="submit"
                  size="wide"
                >
                  {isSaving
                    ? <u-spinner inline />
                    : 'Сохранить'}
                </u-btn>

                {!data.logsCount && (
                  <span class="m-l-auto">
                    <DeleteWithConfirm onConfirm={this.handleDelete} />
                  </span>
                )}
              </footer>
            )}
          </form>
        )}
      </u-modal>
    );
  },
};
</script>
